/**
 * formatWaitTime — converts elapsed seconds to a human-readable string.
 *
 * null  → "—"
 * < 60  → "Ns"
 * < 3600 → "Nm"
 * ≥ 3600 → "Nh Nm"
 */
export function formatWaitTime(waitSeconds: number | null): string {
  if (waitSeconds == null) return '—';
  if (waitSeconds < 60) return `${waitSeconds}s`;
  const totalMinutes = Math.floor(waitSeconds / 60);
  if (totalMinutes < 60) return `${totalMinutes}m`;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}h ${minutes}m`;
}
